import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { GroupResponse, ReportRequest, GroupAverageGradeReportResponse } from "../../models/dtos";

export const groupsApi = createApi({
  reducerPath: "groupsApi",
  baseQuery: baseAuthQuery("Groups"),
  tagTypes: ["Group"],
  endpoints: (builder) => ({
    getGroups: builder.query<ApiResponse<GroupResponse[]>, void>({
      query: () => "",
      providesTags: ["Group"],
    }),
    getGroupById: builder.query<ApiResponse<GroupResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ["Group"],
    }),
    updateGroup: builder.mutation<ApiResponse<GroupResponse>, Partial<GroupResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ["Group"],
    }),
    deleteGroup: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ["Group"],
    }),
    getGroupsBySpecialityIdAndAcademicYear: builder.query<
      ApiResponse<GroupResponse[]>,
      { specialityId: number; academicYearId: number }
    >({
      query: ({ specialityId, academicYearId }) => ({
        url: `GetGroupsBySpecialityIdAndAcademicYear?specialityId=${specialityId}&academicYearId=${academicYearId}`,
      }),
      providesTags: ["Group"],
    }),
    getGroupGradesReport: builder.query<{ blob: Blob; fileName: string }, Partial<ReportRequest>>({
      query: (request) => ({
        url: `getGroupGradesReport`,
        method: "POST",
        body: request,
        responseHandler: async (response) => {
          const blob = await response.blob();
          const fileName = response.headers.get("Content-Disposition")!.split(";")[1].split("=")[1];
          return { blob, fileName };
        },
      }),
      serializeQueryArgs: ({ endpointName }) => endpointName,
    }),
    getGroupsAverageGradeReport: builder.query<ApiResponse<GroupAverageGradeReportResponse[]>, Partial<ReportRequest>>({
      query: (request) => ({
        url: `getGroupsAverageGradeReport`,
        method: "POST",
        body: request,
      }),
    }),
  }),
});
